import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { CycleValidationPostingFile } from './CycleValidationPostingFile';
import { CycleValidationReportFile } from './CycleValidationReportFile';
import { CycleValidationApproval } from './CycleValidationApproval';
import { FileResource } from './FileResource';

export class PostingFileResource extends FBaseService implements FileResource {
  public async getFiles(fiId: string, cycleId: number): Promise<CycleValidationPostingFile[]> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/reporting/${fiId}/posting-files/${cycleId}`);

    const result: CycleValidationPostingFile[] = response.data.data;
    return result;
  }

  public async getReportFiles(fiId: string, cycleId: number): Promise<CycleValidationReportFile[]> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/reporting/${fiId}/cycle-validation-report-files/${cycleId}`);

    const result: CycleValidationReportFile[] = response.data.data;
    return result;
  }

  public async getZeroByteApproval(fiId: string, snapshotId: number): Promise<CycleValidationApproval> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/director/${fiId}/cycle-validation-approval/ZEROBYTE/${snapshotId}`);

    const result: CycleValidationApproval = response.data.data;
    return result;
  }

  public async saveZeroByteApproval(fiId: string, snapshotId: number): Promise<CycleValidationApproval> {
    const approval: CycleValidationApproval = {
      id: null,
      approvalDateTime: null,
      snapshotId,
      approvalUserId: null,
      approvalState: 'APPROVED',
      approvalType: 'ZEROBYTE',
      subFolders: [],
    };
    const response: AxiosResponse = await this.apiClient.put(`/api/rcx/director/${fiId}/cycle-validation-approval`, approval);

    const result: CycleValidationApproval = response.data.data;
    return result;
  }

  /* eslint-disable class-methods-use-this */
  public async filesExpected(fiId: string): Promise<boolean> {
    return true;
  }
  /* eslint-enabled class-methods-use-this */
}

export default PostingFileResource;
